export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/storyboards.fa5e4c2.svg";